/* eslint-disable import/prefer-default-export */
import { useContext } from 'react'
import { OpportunityFormPaginationContext } from '../../context/OpportunityFormPaginationContextProvider'
import { IOpportunityFormPaginationContext } from '../../context/OpportunityFormPaginationContextProvider/types'

export function useOpportunityFormPaginationContext(): IOpportunityFormPaginationContext {
  const context = useContext(OpportunityFormPaginationContext)
  if (context === undefined) {
    throw new Error(
      'useOpportunityFormPaginationContext must be used within an OpportunityFormPaginationProvider',
    )
  }
  return context
}
